import { ESectionColor, Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import * as React from 'react';
import BrainLevel from '../BrainLevel/BrainLevel';
import './LevelSection.scss';

export interface ILevelSectionProps {
  title: string | React.ReactNode;
  subtitle: string;
  isPersonlisedWelcomeMessage?: boolean;
  skeletonClass?: string;
  className?: string;
}

export const LevelSection: React.FC<React.PropsWithChildren<ILevelSectionProps>> = ({
  title,
  subtitle,
  isPersonlisedWelcomeMessage,
  skeletonClass,
  className,
  children,
}) => {
  return (
    <Section noPadding={true} color={ESectionColor.blue} className={`level-section ${className ?? ''}`}>
      <div className="row" data-testid="level-section">
        <div className={`col-6 level-section-content${isPersonlisedWelcomeMessage ? ' lower-padding-bottom' : ''}`}>
          <SectionTitle className={skeletonClass}>{title}</SectionTitle>
          <SectionSubtitle className={skeletonClass}>{subtitle}</SectionSubtitle>
          {children ? <div className={`buttons-container`}>{children}</div> : null}
        </div>
        <div className="col-1 level-section-gap" />
        <BrainLevel className="col-5 level-section-illustration" />
      </div>
    </Section>
  );
};
export default LevelSection;
